<template>
  <v-app-bar app color="#af0606" dark fixed dense>
    <v-avatar tile class="mr-2">
      <img
        src="https://www.vodafone.it/portal/assets/img/menu/vodafone-logo.png"
        alt="logo"
      />
    </v-avatar>
    <v-toolbar-title>
      <span class="text-uppercase font-weight-light">Video</span
      ><span class="text-uppercase font-weight-bold">Assistenza</span>
    </v-toolbar-title>
  </v-app-bar>
</template>

<script>
export default {
  name: 'PublicTitleBar',
  created() {
    this.$vuetify.theme.themes.light.primary = '#e60000'
    this.$vuetify.theme.dark = false
  },
}
</script>
